import { dialog } from "../../../../nq-component";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import DialogModal from "../../../../components/Dialog";
import { findObjectUseCase } from "../../../../usecases/object";
import { auditLogUseCase } from "../../../../usecases/logs";
import {
  createAuditLog,
  findBackupComponent,
  findComponentBySku,
  findInventoryBySku,
  updateInventoryQuantity,
} from "./utils/helperFunc";

class PullOutFormPresenter extends BaseFormPresenter {
  async onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    const view = this.view;

    // Click X
    if (field === "component" && (!value || Object.keys(value).length === 0)) {
      view.setState({
        object: {
          ...view.state.object,
          component: null,
          componentId: null,
          quantity: "",
          raw_materials: [],
          otherComponents: [],
        },
        componentBaseQty: null,
        rawMaterialBase: [],
      });
      return;
    }

    // Selecting a component
    if (field === "component" && value?.id) {
      try {
        const [component] = await findObjectUseCase().execute("components", {
          where: { id: value.id },
          limit: 1,
        });

        console.log("pull component", component);

        if (component && Array.isArray(component.raw_materials)) {
          const baseQty = parseFloat(component.quantity) || 1;
          const baseRaw = component.raw_materials.map((item) => ({
            ...item,
            quantity: parseFloat(item.quantity) || 0,
          }));

          const baseOtherComponent = (component?.otherComponents ?? []).map(
            (item) => ({
              ...item,
              quantity: parseFloat(item.quantity) || 0,
            }),
          );
          console.log("baseOtherComponent", baseOtherComponent);
          console.log("baseRaw", baseRaw);

          view.setState((prev) => ({
            object: {
              ...prev.object,
              component: value,
              componentId: component.id,
              quantity: 0,
              raw_materials: baseRaw.map((item) => ({
                ...item,
                quantity: 0,
              })),
              otherComponents: baseOtherComponent.map((item) => ({
                ...item,
                quantity: 0,
              })),
            },
            componentBaseQty: baseQty,
            rawMaterialBase: baseRaw,
            otherComponentBase: baseOtherComponent,
          }));
        }
      } catch (err) {
        console.error("Error loading component", err);
      }
      return;
    }

    // Quantity field changed
    if (field === "quantity") {
      const newQty = parseFloat(value) || 0;
      const baseQty = view.state.componentBaseQty || 1;
      const rawBase = view.state.rawMaterialBase;
      const componentBase = view.state.otherComponentBase;

      console.log("newQty", newQty);
      console.log("baseQty", baseQty);
      console.log("rawBase", rawBase);

      const multiplier = newQty / baseQty;

      // const scaledRaw = rawBase?.map((item) => ({
      //   ...item,
      //   quantity: ((item.quantity || 0) * multiplier).toFixed(2),
      // }));

      const scaledRaw = rawBase?.map((item) => ({
        ...item,
        quantity: (newQty * (item.quantity || 0)).toFixed(2),
      }));

      console.log("scaledRaw", scaledRaw);

      const scaledOther = componentBase?.map((item) => ({
        ...item,
        // quantity: ((item.quantity || 0) * multiplier).toFixed(2),
        quantity: (newQty * (item.quantity || 0)).toFixed(2),
      }));
      view.setState({
        object: {
          ...view.state.object,
          quantity: newQty,
          raw_materials: scaledRaw,
          otherComponents: scaledOther,
        },
      });
      return;
    }

    // Fallback generic field change
    view.setObject({
      ...view.state.object,
      [field]: value,
    });
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = {
        include: [
          "component",
          "component.uom",
          "raw_materials",
          "raw_materials.uom",
          "uom",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async deductRawMaterial(raw, user, pulloutResponse, collection) {
    const rawId = raw.id;
    const rawSKU = raw.sku;
    const rawItemName = raw?.itemName;
    const pulloutQty = parseFloat(raw.quantity) || 0;

    if (!rawId || isNaN(pulloutQty)) return;

    const inventory = await findInventoryBySku(rawSKU, user);

    if (!inventory || inventory.systemCount === undefined) {
      return;
    }

    const currentStock = parseFloat(inventory.systemCount) || 0;
    const newStock = currentStock - pulloutQty;

    const responseInv = await updateInventoryQuantity(inventory.id, newStock);

    await this._saveReceivableTransaction({
      storeId: { id: user?.storeAnalytic?.[0]?.id },
      sku: rawSKU,
      item_name: rawItemName,
      transaction_type: "Pull Out From Backup",
      quantity: String(-pulloutQty),
      business_date: new Date().toISOString(),
      reference_id: pulloutResponse?.id,
    });

    await createAuditLog({
      user,
      message: `Deducting ${pulloutQty} from ${inventory.itemName}, new stock: ${newStock}`,
      collection,
      objectId: pulloutResponse.id,
      payload: {
        savingPofb: pulloutResponse || null,
        updatingInventory: responseInv,
      },
    });
  }

  async processRawMaterialsDeduction(
    rawMaterials,
    user,
    pulloutResponse,
    collection,
  ) {
    for (const raw of rawMaterials) {
      await this.deductRawMaterial(raw, user, pulloutResponse, collection);
    }
  }

  async processMainComponentAddition(user, response) {
    const mainComponentSku = this.view?.state?.object?.component?.sku;

    if (!mainComponentSku) return;

    const component = await findComponentBySku(mainComponentSku);

    if (!component) return;

    const inventory = await findInventoryBySku(component.sku, user);

    if (!inventory) return;

    const currentStock = parseFloat(inventory.systemCount) || 0;
    const addQuantity = parseFloat(component.quantity) || 0;
    const newStock = currentStock + addQuantity;

    await updateInventoryQuantity(inventory.id, newStock);

    await this._saveReceivableTransaction({
      storeId: { id: user?.storeAnalytic?.[0]?.id },
      sku: component.sku,
      item_name: component.itemName,
      transaction_type: "Pull Out From Backup",
      quantity: String(addQuantity),
      business_date: new Date().toISOString(),
      reference_id: response?.id,
    });
  }

  async deductOtherComponent(component, user, pulloutResponse) {
    const componentSku = component.sku;
    const componentItemName = component.itemName;
    const pulloutQty = parseFloat(component.quantity) || 0;

    if (!componentSku || isNaN(pulloutQty)) return;

    const inventoryComponent = await findInventoryBySku(componentSku, user);

    if (!inventoryComponent || inventoryComponent.systemCount === undefined) {
      return;
    }

    const currentSystemCount = parseFloat(inventoryComponent.systemCount) || 0;
    const newQty = currentSystemCount - pulloutQty;

    const responseComponent = await updateInventoryQuantity(
      inventoryComponent.id,
      newQty,
    );

    await this._saveReceivableTransaction({
      storeId: { id: user?.storeAnalytic?.[0]?.id },
      sku: componentSku,
      item_name: componentItemName,
      transaction_type: "Pull Out From Backup",
      quantity: String(-pulloutQty),
      business_date: new Date().toISOString(),
      reference_id: pulloutResponse?.id,
    });

    await createAuditLog({
      user,
      message: `Deducting ${pulloutQty} from component ${componentItemName} (SKU: ${componentSku}), new quantity: ${newQty}`,
      collection: "backup_pullouts",
      objectId: inventoryComponent.id,
      payload: {
        pulloutRecord: pulloutResponse || null,
        updatingComponent: responseComponent,
      },
    });
  }

  async processOtherComponentsDeduction(
    otherComponents,
    user,
    pulloutResponse,
  ) {
    for (const component of otherComponents) {
      await this.deductOtherComponent(component, user, pulloutResponse);
    }
  }

  async savePulloutRecord(collection) {
    const response = await this.upsertUseCase.execute(collection, this.change);
    return response;
  }

  async validateSingleComponent(component, user) {
    const componentSku = component.sku;
    const pulloutQty = parseFloat(component.quantity) || 0;

    if (!componentSku || isNaN(pulloutQty)) return;

    const backupComponent = await findBackupComponent(componentSku, user);

    // if (!backupComponent) {
    //   throw new Error(
    //     `Component with SKU "${componentSku}" (${component.itemName}) not found in Pull Out From Back Up. Cannot proceed with save.`,
    //   );
    // }
  }

  async validateOtherComponents(otherComponents, user) {
    if (otherComponents.length === 0) return;

    for (const component of otherComponents) {
      await this.validateSingleComponent(component, user);
    }
  }

  prepareData() {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();

    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    this.change.component = { id: this.change.component.id };
    this.change.rawMaterials = this.view.state.object.raw_materials;
    this.change.otherComponents = this.view.state.object.otherComponents;
    this.change.storeId = { id: user.storeAnalytic[0]?.id };

    console.log("Before Send: ", this.change);

    return {
      collection,
      user,
      otherComponents: this.view.state.object.otherComponents || [],
      rawMaterials: this.view.state.object.raw_materials || [],
    };
  }

  async save() {
    this.view.showProgressDialog();

    try {
      const { collection, user, otherComponents, rawMaterials } =
        this.prepareData();

      await this.validateOtherComponents(otherComponents, user);

      const response = await this.savePulloutRecord(collection);

      await this.processOtherComponentsDeduction(
        otherComponents,
        user,
        response,
      );
      await this.processMainComponentAddition(user, response);
      await this.processRawMaterialsDeduction(
        rawMaterials,
        user,
        response,
        collection,
      );

      this.change = {};
      this.view.hideProgressDialog();
    } catch (error) {
      this.view.hideProgressDialog();
      console.error("Error during save/deduct:", error);
      throw error;
    }
  }

  async _saveReceivableTransaction(inventoryItem) {
    try {
      // const payload = {
      //   storeId: { id: storeId },
      //   sku: material.sku,
      //   item_name: material.itemName,
      //   transaction_type: "Direct Purchase",
      //   quantity: String(material.quantity),
      //   business_date: new Date().toISOString(),
      //   reference_id: directPurchaseResponse?.id,
      // };
      console.log("inventoryItem", inventoryItem);
      await this.upsertUseCase.execute("inventory_transaction", inventoryItem);
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    // if (Object.values(this.change).length === 0) {
    //   this.view.showSuccessSnackbar("Successfully saved!");
    //   return;
    // }
    try {
      this.view.submitting();
      dialog.close();
      await this.save();

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default PullOutFormPresenter;
